export default __webpack_public_path__ + "b37f24e4f3035b7e60930a08ab1432f6.png";